export class SearchCondition {
  lesson_code: string = ""
  nendo: string = ""
  lesson_class_no: string = ""
  subject_code: string = null
  start_datetime_at: string = ""
  end_datetime_at: string = ""
  status: string = ""
  is_published: boolean = null
  page: number = 1
  row_count: number =  50
  currentPage: number = 1
}

export class LessonClass {
  lesson_class_id: number
  kyouzai_base_sheet_id: number
  test_base_sheet_id: number
  lesson_code: string
  nendo: number
  lesson_class_no: number
  name: string
  subject_code: string
  subject_name: string
  tantou_login_id: string
  user_name: string
  start_datetime_at: Date
  end_datetime_at: Date
  is_published: boolean
  point: string
  kyouzai_field_names_completed: boolean
  kyouzai_field_positions_completed: boolean
  kyouzai_score_positions_completed: boolean
  kyouzai_answer_image_completed: boolean
  kyouzai_explanation_image_completed: boolean
  kyouzai_status: boolean
  test_field_names_completed: boolean
  test_corretct_image_completed: boolean
  test_field_positions_completed: boolean
  test_score_positions_completed: boolean
  test_answer_image_completed: boolean
  test_question_image_completed: boolean
  is_checked: boolean = false
  test_status: boolean
  questionnaire_group_id: number

  constructor(x: any){
    this.lesson_class_id = x.lesson_class_id
    this.kyouzai_base_sheet_id = x.kyouzai_base_sheet_id
    this.test_base_sheet_id = x.test_base_sheet_id
    this.lesson_code = x.lesson_code
    this.nendo = x.nendo
    this.lesson_class_no = x.lesson_class_no
    this.name = x.name
    this.subject_code = x.subject_code
    this.subject_name = x.subject_name
    this.tantou_login_id = x.tantou_login_id
    this.user_name = x.user_name
    this.start_datetime_at = x.start_datetime_at
    this.end_datetime_at = x.end_datetime_at
    this.is_published = x.is_published
    this.point = x.point
    this.kyouzai_field_names_completed = x.kyouzai_field_names_completed
    this.kyouzai_field_positions_completed = x.kyouzai_field_positions_completed
    this.kyouzai_score_positions_completed = x.kyouzai_score_positions_completed
    this.kyouzai_answer_image_completed = x.kyouzai_answer_image_completed
    this.kyouzai_explanation_image_completed = x.kyouzai_explanation_image_completed
    this.test_field_names_completed = x.test_field_names_completed
    this.test_corretct_image_completed = x.test_corretct_image_completed
    this.test_field_positions_completed = x.test_field_positions_completed
    this.test_score_positions_completed = x.test_score_positions_completed
    this.test_answer_image_completed = x.test_answer_image_completed
    this.test_question_image_completed = x.test_question_image_completed
    this.questionnaire_group_id = x.questionnaire_group_id
    this.is_checked = x.is_checked
  }
}